export const RATINGS = {
  good: {
    label: "Buena",
    hint: "Sin acciones pendientes",
    icon: "pi pi-check-circle",
  },
  regular: {
    label: "Regular",
    hint: "Requiere atención",
    icon: "pi pi-exclamation-circle",
  },
  bad: {
    label: "Mala",
    hint: "Atención prioritaria",
    icon: "pi pi-exclamation-triangle",
  },
  na: { label: "No revisado / no aplica" },
};
export const STATUSES = {
  pending: "Pendiente",
  in_progress: "En atención",
  verification: "Por verificar",
  closed: "Cerrada",
  no_action: "Sin acciones pendientes",
};
export const ACTIONS = {
  created: "Inspección registrada",
  acknowledge: "Recepción confirmada",
  start: "Atención iniciada",
  submit: "Corrección enviada",
  close: "Inspección cerrada",
  return: "Devuelta para corrección",
  comment: "Comentario",
  support: "Apoyo técnico solicitado",
  assign: "Responsable reasignado",
};
export const categories = (type) => [
  {
    key: "exterior",
    label: "Limpieza exterior",
    hint: "Frente, pantalla, botones y entrega",
    icon: "pi pi-sun",
  },
  {
    key: "interior",
    label: "Limpieza interior",
    hint: "Residuos, derrames y suciedad visible",
    icon: "pi pi-box",
  },
  {
    key: "physical",
    label: "Estado físico",
    hint: "Puerta, cerradura, vidrio y piezas",
    icon: "pi pi-shield",
  },
  {
    key: "operation",
    label: "Funcionamiento",
    hint: "Operación y entrega del producto",
    icon: "pi pi-cog",
  },
  {
    key: "stock",
    label: "Abastecimiento",
    hint: "Disponibilidad y estado de los insumos",
    icon: "pi pi-shopping-bag",
  },
  {
    key: "specific",
    label: type === "coffee" ? "Sistema de café" : "Sistema de snack",
    hint:
      type === "coffee"
        ? "Boquillas, bandeja y fugas de agua"
        : "Espirales, canales y área de entrega",
    icon: "pi pi-sliders-h",
  },
];
export const fullName = (user) =>
  [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
  "Sin responsable";
export const formatDate = (date) =>
  new Intl.DateTimeFormat("es", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(date));
export function validateStep(step, draft) {
  if (step === 0 && !draft.machineId)
    return "Selecciona una máquina para continuar.";
  if (step === 1) {
    if (draft.checklist.some((row) => !row.rating))
      return "Evalúa las seis categorías. Puedes marcar «No revisado / no aplica».";
    if (draft.checklist.every((row) => row.rating === "na"))
      return "Evalúa al menos una categoría.";
    if (
      draft.checklist.some(
        (row) => ["regular", "bad"].includes(row.rating) && !row.note.trim()
      )
    )
      return "Describe el hallazgo en cada categoría regular o mala.";
  }
  if (step === 2) {
    if (!draft.rating) return "Selecciona la calificación general.";
    if (
      draft.rating === "good" &&
      draft.checklist.some((row) => ["regular", "bad"].includes(row.rating))
    )
      return "Hay hallazgos pendientes: selecciona Regular o Mala.";
    if (!draft.photos.length)
      return "Adjunta al menos una fotografía de evidencia.";
    if (!draft.comment.trim()) return "Escribe el comentario final.";
  }
  return "";
}
